import { createGlobalState } from '@vueuse/core';
// import { defineStore } from 'pinia';
import { ref, computed, defineAsyncComponent } from 'vue';

const loadComponent = (name, payload = {}, closeAllOnX = false) => ({
    component: defineAsyncComponent(() => import(`@vuejs/modal/${name}.vue`)),
    payload,
    closeAllOnX,
});

export const useSharedModal = createGlobalState(() => {
    const componentsStack = ref([]);
    const modalOptions = ref({
        size: '',
        centered: false,
    });

    const getCurrent = computed(() => componentsStack.value.at(-1));
    const getAmount = computed(() => componentsStack.value.length);

    /**
     * Shows the offcanvas with the specified component name.
     *
     * @param {string} componentName - The name of the component to display in the offcanvas.
     * @returns {Promise<void>} A promise that resolves when the offcanvas is shown.
     */
    const show = async (componentName, payload = {}, options = {}) => {
        window.bootstrap.modal.show();
        console.log('show', componentName);

        // @ts-ignore - this is a dynamic import
        componentsStack.value.push(
            loadComponent(componentName, payload, options.closeAllOnX === true)
        );
    };

    const setModalOptions = async (options) => {
        modalOptions.value = { ...modalOptions.value, ...options };
        return modalOptions.value;
    };

    const replace = (componentName, payload = {}, options = {}) => {
        componentsStack.value.pop();
        // @ts-ignore - this is a dynamic import
        componentsStack.value.push(
            loadComponent(componentName, payload, options.closeAllOnX === true)
        );
    };

    /**
     * Hides the currently opened offcanvas
     *
     * @returns {Promise<void>} A promise that resolves when the offcanvas is shown.
     */
    const hide = async () => {
        componentsStack.value.pop();

        if (componentsStack.value.length === 0) {
            window.bootstrap.modal.hide();
        }
    };

    const hideAll = () => {
        componentsStack.value = [];
        window.bootstrap.modal.hide();
    };

    return {
        componentsStack,
        getCurrent,
        modalOptions,
        setModalOptions,
        getAmount,
        show,
        replace,
        hide,
        hideAll,
    };
});
